import { useReactiveVar } from "@apollo/client";
import { useEffect, useMemo, useState } from "react";
import * as Styled from "./style";
import { VideoStageSeasonTabContents } from "./video-stage-season-tab-contents";
import { VideoStageSeasonTabTitle } from "./video-stage-season-tab-title";
import { useRouter } from "next/router";
import { STAGE_SELECT_TABS } from "~/components/blocks/product/const";
import { isVideoStageSeason } from "~/components/blocks/product/type-guard";
import { isFirstFocusPurchasedTabVar } from "~/components/stores/detail-product/store";
import { PATHS } from "~/const/paths";
import type { G_GetVideoQuery } from "~/lib/graphql";

type VideoStageSeasonTabProps = {
  videoData: G_GetVideoQuery["video"];
};

/** 作品末端 | 舞台 | タブとそのタブに紐づくコンテンツを表示するコンポーネント */
export const VideoStageSeasonTab = (props: VideoStageSeasonTabProps) => {
  const { videoData } = props;
  const router = useRouter();
  const isPurchaseProduct = useReactiveVar(isFirstFocusPurchasedTabVar);
  const isCurrentLibraryPage = `${router.pathname}/` === PATHS.MY_LIBRARY;
  const isPurchase = isPurchaseProduct || isCurrentLibraryPage;
  const defaultTabValue = useMemo(() => {
    if (isPurchase) return STAGE_SELECT_TABS.PURCHASED;
    if (isVideoStageSeason(videoData) && videoData.allPerformances.length === 0) return STAGE_SELECT_TABS.PRODUCT_INFO;

    return STAGE_SELECT_TABS.DELIVERY;
  }, [isPurchase, videoData]);
  const [selectedTabValue, setSelectedTabValue] = useState<string>(defaultTabValue);
  const onChangeTabValue = (v: string) => {
    setSelectedTabValue(v);
  };

  const totalDeliveryLength = useMemo(() => {
    if (isVideoStageSeason(videoData)) {
      return videoData.allPerformances.length;
    }

    return 0;
  }, []);

  const totalPurchasedCount = useMemo(() => {
    if (isVideoStageSeason(videoData)) {
      if (videoData.purchasedContents !== undefined && videoData.purchasedContents !== null) {
        return videoData.purchasedContents.total;
      }
    }

    return 0;
  }, []);

  // memo:useStateの値は、setterが走るまで再レンダリングされても変更されないためこちらの処理が必要
  useEffect(() => {
    if (!isPurchase) return;
    setSelectedTabValue(defaultTabValue);
    isFirstFocusPurchasedTabVar(false);
  }, [defaultTabValue]);

  return (
    <Styled.ArticleRootTab>
      <VideoStageSeasonTabTitle
        selectedTabValue={selectedTabValue}
        onChangeTabValue={onChangeTabValue}
        totalDeliveryLength={totalDeliveryLength}
        totalPurchasedLength={totalPurchasedCount}
      />

      <VideoStageSeasonTabContents
        videoData={videoData}
        selectedTabValue={selectedTabValue}
        totalPurchasedLength={totalPurchasedCount}
      />
    </Styled.ArticleRootTab>
  );
};
